/* Machine Fitness — Homepage behaviour
   Lightweight enhancements. Most of the page is static markup. */

(function () {
  'use strict';

  // Marquee — duplicate the track once on load to ensure a seamless loop.
  // The CSS animation translates the track -100%; duplicating contents fills the gap.
  document.querySelectorAll('[data-mf-marquee]').forEach(function (m) {
    var track = m.querySelector('.marquee-track');
    if (!track || track.dataset.doubled === '1') return;
    track.dataset.doubled = '1';
    track.innerHTML = track.innerHTML + track.innerHTML;
  });

  // Newsletter form — AJAX post if it's a real Shopify customer form.
  document.querySelectorAll('[data-mf-newsletter]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      // Let Shopify's customer form handle submission natively. We just give
      // an inline confirmation if data-inline-confirm is set.
      if (form.dataset.inlineConfirm !== '1') return;
      e.preventDefault();
      var fd = new FormData(form);
      fetch(form.action, { method: 'POST', body: fd })
        .then(function () {
          var msg = form.querySelector('[data-confirm]');
          if (msg) msg.style.display = '';
          form.querySelector('input[type="email"]').value = '';
        })
        .catch(function () { form.submit(); });
    });
  });

  // Theme-editor friendliness: re-run the marquee doubler when a section reloads.
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-mf-marquee]').forEach(function (m) {
      var track = m.querySelector('.marquee-track');
      if (!track || track.dataset.doubled === '1') return;
      track.dataset.doubled = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  });
})();
